import { render, staticRenderFns } from "./ProjectGroupsTable.vue?vue&type=template&id=381b91b8&"
import script from "./ProjectGroupsTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports